import request from "@/common/request.js";

export function GetAboutData(data) {
  return request({
    url: "/system/profile/list",
    method: "post",
    params: data,
  });
}
